import { useState, useEffect } from "react";

// sending messages
function localPublish<U>(message: U) {
  window.eventBus.publish("WS_OUT", message);
}

export function useWebSocket<T, U>(): [T, (message: U) => void] {
  const [messages, setMessages] = useState<T>({ event: "" } as T);

  // receiving messages
  useEffect(() => {
    const updateMessageStateFn = (event: { channel: string, payload: T | undefined }): void => {
      if (!event.payload) {
        return;
      }
      setMessages(event.payload);
    };
    let sub: { unsubscribe: () => void };
    void (async () => {
      sub = await window.eventBus.subscribe("WS_IN", updateMessageStateFn);
    })();
    return () => {
      if (sub) {
        sub.unsubscribe();
      }
    };
  }, []);

  return [messages, localPublish];
}
